/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V1RebuildGlobalSearchResourceType } from '../models/V1RebuildGlobalSearchResourceType';
import { HttpFile } from '../http/http';

export class V1RebuildGlobalSearchRequest {
    /**
    * IDs of Org to be rebuilt. Leave empty to rebuild all Orgs.
    */
    'orgIds'?: Array<string>;
    /**
    * Resource type to be rebuilt. Leave empty to rebuild all resource types.
    */
    'resourceTypes'?: Array<V1RebuildGlobalSearchResourceType>;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "orgIds",
            "baseName": "org_ids",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "resourceTypes",
            "baseName": "resource_types",
            "type": "Array<V1RebuildGlobalSearchResourceType>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V1RebuildGlobalSearchRequest.attributeTypeMap;
    }

    public constructor() {
    }
}

